import React from 'react'
import { useTable } from 'react-table'
import styled from 'styled-components'


function CreateTable({ columns, data }) {
    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns,
        data,
    })

    // Render the UI for your table
    return (
        <table {...getTableProps()}>
            <thead>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

const TableStyles = styled.div`
padding: 1rem;

table {
    border-spacing: 0;
    height: 100%;
    width: 100%;
    
    th,
    td {
    margin: 0;
    padding: 0.5rem;
    border-bottom: 1px solid #cdcdcd;
    font-size: 0.9em
    }
}   
`

export { CreateTable, TableStyles }